import * as React from 'react';
import { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { TransitionProps } from '@mui/material/transitions';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

interface UpgradeContactDialogProps {
    open: boolean;
    handleClose: () => void;
}

const UpgradeContactDialog: React.FC<UpgradeContactDialogProps> = ({
    open,
    handleClose,
}) => {
    const currentUser = useSelector((state: any) => state.user.currentUser);
    const [formInput, setFormInput] = useState({
        firstName: currentUser.firstName || '',
        lastName: currentUser.lastName || '',
        email: currentUser.userId || '',
        phoneNumber: currentUser.phoneNumber || '',
        organization: currentUser.company || '',
        comment: '',
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormInput({
            ...formInput,
            [name]: value,
        });
    };

    const handleCleanup = () => {
        setFormInput({
            firstName: currentUser.firstName || '',
            lastName: currentUser.lastName || '',
            email: currentUser.userId || '',
            phoneNumber: currentUser.phoneNumber || '',
            organization: currentUser.company || '',
            comment: '',
        });
        handleClose();
    };

    const inputs = [
        {
            name: 'firstName',
            label: 'First Name',
            type: 'text',
            multi: false,
            required: true,
        },
        {
            name: 'lastName',
            label: 'Last Name',
            type: 'text',
            multi: false,
            required: true,
        },
        {
            name: 'email',
            label: 'Email Address',
            type: 'email',
            multi: false,
            required: true,
        },
        {
            name: 'phoneNumber',
            label: 'Phone Number',
            type: 'tel',
            multi: false,
            required: true,
        },
        {
            name: 'organization',
            label: 'Organization',
            type: 'text',
            multi: false,
            required: false,
        },
        {
            name: 'comment',
            label: 'Comment',
            type: 'text',
            multi: true,
            required: false,
        },
    ];

    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
                maxWidth={'sm'}
                fullWidth
            >
                <DialogTitle color={'primary'} sx={{ fontWeight: 'bold' }}>
                    Upgrade to a Paid Plan
                </DialogTitle>
                <form action="https://formspree.io/f/mdoqzkaz" method="POST">
                    <DialogContent>
                        <DialogContentText>
                            Elevate your Health Data Explorer experience with
                            our premium subscription plan, exclusively available
                            through direct contact with our sales team. Dive
                            into automated analysis, tailor configurations to
                            your needs, and receive personalized support from
                            our experts. Reach out to us today to upgrade and
                            revolutionize your health data exploration journey.
                        </DialogContentText>
                        <Box component="section" sx={{ p: 2 }}>
                            {inputs.map((input, i) => {
                                return (
                                    <TextField
                                        key={`upgrade-${input.name}`}
                                        autoFocus={input.name === 'firstName'}
                                        required={input.required}
                                        margin="dense"
                                        id={input.name}
                                        name={input.name}
                                        label={input.label}
                                        fullWidth
                                        variant="outlined"
                                        onChange={handleChange}
                                        value={formInput[input.name]}
                                        multiline={input.multi}
                                        minRows={input.multi ? 3 : 1}
                                    />
                                );
                            })}
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCleanup}>Cancel</Button>
                        <Button
                            type="submit"
                            variant={'contained'}
                            color={'primary'}
                            onClick={handleCleanup}
                        >
                            Contact
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </React.Fragment>
    );
};

export default UpgradeContactDialog;
